/**
 * Bridge to Apple In-App Purchase inside the iOS app. Only available in app
 * builds that include the StoreKit plugin; older builds and the website see
 * `iapAvailable() === false` and nothing changes for them.
 */
import { Capacitor, registerPlugin } from "@capacitor/core";
import { isNativeApp, nativePlatform } from "@/lib/native-app";

export const APPLE_PRODUCT_IDS = [
  "com.recoverytrauma.app.membership.monthly",
  "com.recoverytrauma.app.membership.6month",
  "com.recoverytrauma.app.membership.yearly",
] as const;

export type AppleProduct = {
  id: string;
  title: string;
  description: string;
  displayPrice: string;
  price: number;
  period: string;
};

type RTStoreKitPlugin = {
  getProducts(o: { productIds: string[] }): Promise<{ products: AppleProduct[] }>;
  purchase(o: { productId: string; appAccountToken?: string }): Promise<{
    status: "purchased" | "pending" | "cancelled" | "unknown";
    transactionId?: string;
  }>;
  currentEntitlements(): Promise<{ transactionIds: string[] }>;
  restore(): Promise<{ transactionIds: string[] }>;
  manageSubscriptions(): Promise<void>;
  addListener(
    e: "transactionUpdated",
    cb: (d: { transactionId: string }) => void,
  ): Promise<{ remove: () => void }>;
};

export const RTStoreKit = registerPlugin<RTStoreKitPlugin>("RTStoreKit");

export function iapAvailable(): boolean {
  return isNativeApp() && nativePlatform() === "ios" && Capacitor.isPluginAvailable("RTStoreKit");
}
